<div class="body" [formGroup]="formGroup">

    <div formArrayName="items" class="content">

        <table mat-table [dataSource]="itemControl.controls|sortedFormArray:active:direction:itemControl.value.length" class="table" matSort (matSortChange)="sortData($event)" [matSortActive]="active" [matSortDirection]="direction">

            <ng-container matColumnDef="position">
                <th mat-header-cell mat-sort-header="itemposition" *matHeaderCellDef>Pos.</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <input formControlName="itemposition" class="input very-tight" matInput #ref type="number" />

                </td>
                <td mat-footer-cell *matFooterCellDef [attr.colspan]="6">
                    {{itemControl.value.length === 0? 'keine Artikel': itemControl.value.length + ' Artikel'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="name">
                <th mat-header-cell mat-sort-header="itemname" *matHeaderCellDef>Bezeichnung</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <input formControlName="itemname" class="input medium" matInput #ref />

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="count">
                <th mat-header-cell mat-sort-header="itemcount" *matHeaderCellDef>Anzahl</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <input formControlName="itemcount" class="input very-tight" matInput #ref type="number" (input)="updateCosts()" />

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="product">
                <th mat-header-cell mat-sort-header="itemproduct" *matHeaderCellDef>Produkt</th>
                <td mat-cell *matCellDef="let element" class="product-cell" [formGroup]="element.value" (click)="ref.focus()">

                    <app-select-product-form 
                        formControlName="itemproduct" 
                        class="input tight"
                        (productChanged)="itemProductChanged($event, element.value)" matInput #ref>
                    </app-select-product-form>

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="description">
                <th mat-header-cell mat-sort-header="itemdesc" *matHeaderCellDef>Beschreibung</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <input formControlName="itemdesc" class="input" matInput #ref />

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="info">
                <th mat-header-cell mat-sort-header="iteminfo" *matHeaderCellDef>Bemerkung</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <input formControlName="iteminfo" class="input" matInput #ref />

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="setupcost">
                <th mat-header-cell mat-sort-header="itemsetupcost" *matHeaderCellDef>Einrichtung</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" tabindex="0"
                    (focus)="proxyFocus(ref)">

                    <input formControlName="itemsetupcost" class="input tight" matInput #ref=hiddenInput appHiddenInput
                        type="number" (input)="updateSetupCost()" />

                    <label *ngIf="!ref.focussed">
                        {{element.value.controls['itemsetupcost'].value? (element.value.controls['itemsetupcost'].value|currency:'EUR':'symbol'): '-'}}
                    </label>

                </td>
                <td mat-footer-cell *matFooterCellDef class="currency-footer">
                    {{totalSetupCost|currency:'EUR':'symbol'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="rentalcost">
                <th mat-header-cell mat-sort-header="itemrentalcost" *matHeaderCellDef>Miete</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" tabindex="0"
                    (focus)="proxyFocus(ref)">

                    <input formControlName="itemrentalcost" class="input tight" matInput #ref=hiddenInput appHiddenInput
                        type="number" (input)="updateRentalCost()" />
                    <label *ngIf="!ref.focussed">
                        {{element.value.controls['itemrentalcost'].value? (element.value.controls['itemrentalcost'].value|currency:'EUR':'symbol'): '-'}}
                    </label>

                </td>
                <td mat-footer-cell *matFooterCellDef class="currency-footer">
                    {{totalRentalCost|currency:'EUR':'symbol'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="purchasecost">
                <th mat-header-cell mat-sort-header="itempurchasecost" *matHeaderCellDef>Kauf</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" tabindex="0"
                    (focus)="proxyFocus(ref)">

                    <input formControlName="itempurchasecost" class="input tight" matInput #ref=hiddenInput
                        appHiddenInput type="number" (input)="updatePurchaseCost()" />

                    <label *ngIf="!ref.focussed">
                        {{element.value.controls['itempurchasecost'].value? (element.value.controls['itempurchasecost'].value|currency:'EUR':'symbol'): '-'}}
                    </label>

                </td>
                <td mat-footer-cell *matFooterCellDef class="currency-footer">
                    {{totalPurchaseCost|currency:'EUR':'symbol'}}
                </td>
            </ng-container>

            <ng-container matColumnDef="buildInDate">
                <th mat-header-cell mat-sort-header="itembuildindate" *matHeaderCellDef>Einbau</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <div class="date-wrapper">

                        <input formControlName="itembuildindate" class="input" matInput #ref [matDatepicker]="picker" (focus)="picker.open()" readonly />
                        <mat-icon>today</mat-icon>
                        <mat-datepicker #picker></mat-datepicker>

                    </div>

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="faktDate">
                <th mat-header-cell mat-sort-header="itemfaktdate" *matHeaderCellDef>Fakturierung</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <div class="date-wrapper">

                        <input formControlName="itemfaktdate" class="input" matInput #ref [matDatepicker]="picker" (focus)="picker.open()" readonly />
                        <mat-icon>today</mat-icon>
                        <mat-datepicker #picker></mat-datepicker>

                    </div>

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="cancelDate">
                <th mat-header-cell mat-sort-header="itemcanceldate" *matHeaderCellDef>Künd.</th>
                <td mat-cell *matCellDef="let element" [formGroup]="element.value" (click)="ref.focus()">

                    <div class="date-wrapper">

                        <input formControlName="itemcanceldate" class="input" matInput #ref [matDatepicker]="picker" (focus)="picker.open()" readonly />
                        <mat-icon>today</mat-icon>
                        <mat-datepicker #picker (click)="picker.open()"></mat-datepicker>

                    </div>

                </td>
                <td mat-footer-cell *matFooterCellDef></td>
            </ng-container>

            <ng-container matColumnDef="controls">

                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="control-cell">

                    <button mat-icon-button color="warn" [disabled]="disabled" (click)="removeItem(element.key)">
                        <mat-icon>delete_forever</mat-icon>
                    </button>

                </td>
                <td mat-footer-cell *matFooterCellDef></td>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="columns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: columns;" class="body-row" [class.danger]="row.value.controls['itemcanceldate'].value|beforeYet"></tr>
            <tr mat-footer-row *matFooterRowDef="footerColumns; sticky: true"></tr>

        </table>

    </div>

</div>
